import React from 'react';
import TopBar from "../components/TopBar";
import Footer from "../components/Footer";
import "../App.css";
import ContactForm from '../components/ContactForm';

function Connect() {
  return (
    <div className="App">
      <TopBar />
      <div className="App-header-services" style={{ padding: '8vw 8px 8px 8px', minHeight: '60vh' }}>
        <div className="connected-text" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h1 className="hero-title">Stay Connected</h1>
          <p className="hero-subtitle" style={{ fontSize: '1.2rem', color: '#333', marginBottom: '32px' }}>
At CHC, we’re here to care for your loved ones — and to bring you peace of mind. Our professional caregivers and personal support workers see their work as a sacred service, not just a job. With compassion at the heart of everything we do, we treat your loved ones like our own family — with respect, patience, and genuine care. We understand that entrusting someone else with your loved one’s care can be emotional and stressful. That’s why we maintain open, transparent communication and provide quick, regular reports to keep you informed every step of the way. With CHC, you can rest easy knowing your loved one is in caring, capable hands — allowing you to focus on your own responsibilities while we provide the support, comfort, and attention they deserve.          
          </p>
          {/* <p style={{ fontSize: '1rem', color: '#555' }}>
            At Connection Seniorcare, we believe in fostering meaningful relationships and ensuring seamless communication with our clients and their families.
          </p> */}
        </div>
      </div>
      <ContactForm />
      <Footer />
    </div>
  );
}

export default Connect;